import { AuthService } from './auth.service';
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {

  constructor(private injector : Injector, private authService : AuthService) { }
  intercept(req: HttpRequest<any>, next : HttpHandler){
    if(!this.authService.getToken()) return next.handle(req);    
    const authReq = req.clone({
      headers: req.headers.set('Authorization', this.authService.getToken())
        .append('Access-Control-Allow-Origin', '*')
    }); 
    return next.handle(authReq);
  }
}
